export function splitTime(milliseconds: number) {
  const totalSeconds = milliseconds > 0 ? Math.floor(milliseconds / 1000) : 0;
  const seconds = totalSeconds % 60;
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const hours = Math.floor(totalSeconds / 60 / 60);
  return { hours, minutes, seconds };
}
